import * as OBC from "@thatopen/components";
import * as OBCF from "@thatopen/components-front";
import World from './World/World.js';
import * as THREE from 'three';
//import Highlighter from "./World/Highlighter.js";
import StatsManager from './Stats.js';
import OBConstantsManager from "../Data/DataManagers/OBConstantsManager.js";
import GeneralEventListener from "./EventListeners/GeneralEventListener.js";
import IFCLoaderSetup from "./IFC/IFCLoaderSetup.js";
import ElementModelManager from "../Data/DataManagers/ElementModelManager.js";
import CustomHighlighter from "./World/CustomHighlighter.js";
import { ViewCube } from "./Threejs/ViewCube.js";


let instance = null;

export default class Experience {
    constructor(container) {
        // Singleton
        if (instance) {
            return instance;
        }
        instance = this;

        // Global access
        window.experience = this;

        // Options
        this.container = container;
        // Components
        this.components = new OBC.Components();
      
        this.world = new World();

        this.Highlighter = new CustomHighlighter();
        
        // Initialize components        
        this.init();
        
        //this.world.world.scene.three.background = new THREE.Color( 0xf8f8f8 );
        this.world.world.scene.three.background = null;

        this.casters = this.components.get(OBC.Raycasters);
        this.caster = this.casters.get(this.world.world);

        this.ifcfileloader = new IFCLoaderSetup();
        this.eventlisteners = new GeneralEventListener()
        this.elementmodelmanager = new ElementModelManager()

        //this.statsManager = new StatsManager();
        this.constants = new OBConstantsManager();

        this.bvhRoot = null;

        this.worldMatrix = null;
  
        this.elementcount = 0;

        //const camera = this.world.world.camera.three;
        
        //const container = this.container;

        // In Experience.js

        this.viewCube = new ViewCube({
            camera: this.world.world.camera,
            renderer: this.world.world.renderer.three,
            container: this.container,
        });

        if (this.viewCube) this.viewCube.update();

        // 🔁 Manual animation loop just for viewcube
        const loop = () => {
            this.viewCube.update();
            requestAnimationFrame(loop);
        };
        loop();


       


    }

    init() {        
        this.components.init();

    }



    getIFCFileByUUID(uuid)
    {
        return this.world.world.scene.three.children.find(m => m.uuid === uuid)
    }



    getAllMeshesFromScene(scene = null) {


        let meshes = [];
    
        function extractMeshes(object) {
            if (object.isMesh) {
                meshes.push(object);
            } else if (object.isGroup || object.isObject3D) {
                object.children.forEach(child => extractMeshes(child));
            }
        }
    
        // Start from index 2 to skip camera and light source
        scene.children.slice(2).forEach(group => extractMeshes(group));

        console.log(meshes)
    
        return meshes;
    }

    getAllMeshesFromObject(scene) {
        //console.log(scene)
        let meshes = [];
    
        function extractMeshes(object) {
            if (object.isMesh) {
                meshes.push(object);
            } else if (object.isGroup || object.isObject3D) {
                object.children.forEach(child => extractMeshes(child));
            }
        }
    
        // Start from index 2 to skip camera and light source
        //scene.forEach(group => extractMeshes(group));

        extractMeshes(scene)
    
        return meshes;
    }

    returnProjectCenter()
    {

        console.log(this.world.world.scene.three)

        const projectMeshes = this.getAllMeshesFromScene(this.world.world.scene.three);
        const meshgroup = new THREE.Group();

        projectMeshes.forEach(item =>
        {
            meshgroup.add(item);


        })


        const boundingBox = new THREE.Box3();
        boundingBox.makeEmpty();
        boundingBox.expandByObject(object);

        const center = new THREE.Vector3();
        boundingBox.getCenter(center);

        return center;

        


    }
    
    returnProjectMeshGroup()
    {

        const projectMeshes = this.getAllMeshesFromScene(this.world.world.scene.three);
        const meshgroup = new THREE.Group();

        projectMeshes.forEach(item =>
        {
            meshgroup.add(item);


        })
        


        return meshgroup;

        


    }

    getMeshfromScene(meshuuid) {
        const projectMeshes = this.getAllMeshesFromScene(this.world.world.scene.three);
        //console.log("Project Meshes", projectMeshes);
        //console.log("Meshuuid", meshuuid);

        return projectMeshes.find(item => {
            //console.log(item.uuid);
            return item.uuid === meshuuid;
        });
    }

    getCameraExperience()
    {
        return this.world.world.camera
    }
}



